"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"logo":"logo_d_fdf","icon":"logo_1Trfm","svg":"logo_X5kuq"};
tokens._getCss = function () {return `/* imported from logo.css */ .logo_d_fdf { height: 100%; width: auto; display: -ms-inline-flexbox; display: inline-flex; -ms-flex-align: center; align-items: center; -ms-flex-pack: center; justify-content: center; } .logo_1Trfm { height: 90%; width: auto; } .logo_X5kuq { height: 100%; width: auto; display: -ms-flexbox; display: flex; max-width: 100%; } .logo_X5kuq path{ fill: currentColor; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/logo/logo_css.js"};
exports["default"] = tokens;